<template>
    <div class="min-title">
        <img src="/images/news/title1.png" alt="">
        <span>{{title}}   </span>
        <img src="/images/news/title2.png" alt="">
    </div>
</template>

<script>
export default {
    name: '',
    props:{
        title:{
            type: String,
            default: '',
        }
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.min-title{
    margin: 30px auto;
    text-align: center;
    height: 24px;
    line-height: 24px;
    width: 100%;
    img{
        margin: 0 4px -2px;
    }

    span{
        font-size: 23px;
    }
    
}
</style>
